var __rspack_ns_object = {"Zoom":"toolTip1"}